import { Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Track } from '@app/core/models/Track';
import { Bac } from '@app/library/models/bac.model';
import {
  TrackArchiveFailure,
  TrackArchiveMultiBacSuccess,
  TrackArchiveRequest,
  TrackArchiveSuccess,
} from '@app/library/states/tracks.actions';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { UiStoreHelperService } from '@radioking/shared/common-services';
import { CloseCurrentPanel } from '@radioking/shared/pannel-manager';
import amplitude from 'amplitude-js';
import { Observable, Subscription } from 'rxjs';

interface DataInput {
  isSingle: boolean;
  bac: Bac;
  track?: Track;
  shortcut: boolean;
  trackIdList?: number[];
  mobile?: boolean;
}

@Component({
  selector: 'rk-archive-track-modal',
  templateUrl: './archive-track-modal.component.html',
  styleUrls: ['./archive-track-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ArchiveTrackModalComponent implements OnInit, OnDestroy {
  isLoading$: Observable<boolean>;
  hasError$: Observable<boolean>;

  subscription = new Subscription();

  constructor(
    public readonly dialogRef: MatDialogRef<ArchiveTrackModalComponent>,
    private readonly store: Store,
    private readonly actions$: Actions,
    private readonly uiStore: UiStoreHelperService,
    private readonly dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public dataIn: DataInput,
  ) {}

  ngOnInit() {
    this.isLoading$ = this.uiStore.getLoadingState(TrackArchiveRequest, [
      TrackArchiveFailure,
      TrackArchiveSuccess,
    ]);

    this.hasError$ = this.uiStore.getErrorState(TrackArchiveRequest, TrackArchiveFailure);

    this.subscription.add(
      this.actions$
        .pipe(ofActionDispatched(TrackArchiveSuccess, TrackArchiveMultiBacSuccess))
        .subscribe(() => {
          this.dialog.closeAll();
          this.store.dispatch(new CloseCurrentPanel());
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onSubmit() {
    amplitude
      .getInstance()
      .logEvent(this.dataIn.shortcut ? 'delete_track_shortcut' : 'delete_track');
    if (this.dataIn.isSingle) {
      this.store.dispatch(
        new TrackArchiveRequest([this.dataIn.track.id], this.dataIn.bac),
      );
    } else {
      this.store.dispatch(
        new TrackArchiveRequest(this.dataIn.trackIdList, this.dataIn.bac),
      );
    }
  }

  onCancel() {
    this.dialogRef.close(false);
  }
  onAbort() {
    this.dialogRef.close(false);
  }
}
